import Templates from 'pages/ga/templates/Index';
import TemplatesForm from 'pages/ga/templates/Form';

const TemplatesRoutes = [
    { index: true, element: <Templates /> },
    { path: 'add', element: <TemplatesForm mode="add" /> },
    {
        path: 'edit/:id',
        element: <TemplatesForm mode="edit" />,
    },
];

export default TemplatesRoutes;
